<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 09:32:37
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-16 16:11:14
-->
<template>
  <div class="card">
    <div class="header">
      <div class="title">创建考试计划</div>
      <el-button class="backBtn" @click="toList">返回</el-button>
    </div>
    <el-tabs v-model="activeIndex" tab-position="left" style="height: 200px;">
      <el-tab-pane label="基本信息设置" name="1">
        <BaseInfo :is-read-only="isReadOnly" @next="next" />
      </el-tab-pane>
      <el-tab-pane label="配置考试科目" name="2">
        <Subject v-if="activeIndex == 2" :is-read-only="isReadOnly" />
      </el-tab-pane>
      <el-tab-pane label="添加考试人员" name="3">
        <Examinee v-if="activeIndex == 3" :is-read-only="isReadOnly" />
      </el-tab-pane>
      <el-tab-pane label="配置监考老师" name="4">
        <Teacher v-if="activeIndex == 4" :is-read-only="isReadOnly" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BaseInfo from './components/BaseInfo.vue'
import Subject from './components/Subject.vue'
import Examinee from './components/Examinee.vue'
import Teacher from './components/Teacher.vue'
export default {
  name: 'ExamPlanAdd',
  components: { BaseInfo, Subject, Examinee, Teacher },
  data() {
    return {
      activeIndex: '1',
    }
  },
  computed: {
    isReadOnly() {
      return this.$route.name == 'ExamPlanRead'
    },
  },
  methods: {
    toList() {
      this.$router.push('/exam/plan')
    },
    next() {
      this.activeIndex = '2'
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  width: 100%;
  height: 100vh;
  background: #ffffff;
  .header {
    height: 72px;
    border-bottom: 1px solid #e8ebf2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px 0 16px;
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #333333;
    }
    .el-button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #3671bf;
      font-size: 14px;
      font-weight: 400;
      color: #3671bf;
    }
  }
  /deep/.el-tabs {
    height: calc(100% - 73px) !important;
    .el-tabs__header {
      padding: 20px;
      border-right: 1px solid #e8ebf2;
      margin-right: 0;
      .el-tabs__item {
        width: 180px;
        height: 60px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 2px solid #f5f5f5;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        &.is-active {
          background-color: #f5f8fc;
          color: #3671bf;
        }
      }
      .el-tabs__nav-wrap {
        height: 240px;
      }
      .el-tabs__nav-wrap::after {
        background-color: #f5f5f5;
      }
    }
    .el-tabs__content {
      height: 100%;
    }
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
